import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Input, Form } from 'antd'
import { compose } from 'react-apollo'
import moment from 'moment'
import 'antd/dist/antd.css'

const FormItem = Form.Item

class SearchBar extends Component {
//     notFound = () => {
//         Modal.warning({
//            title: 'Bib is not found',
//            content: `Sorry your bib number is not found`,
//        })
//    }

    _handleSubmit = (e) => {
      this.props.history.push(`${this.props.event.slug}/${e}`)
    }

  // console.log('e', e)
  // e.preventDefault()
  // this.props.form.validateFields((err, values) => {
  //     if(!err) {
  //         this.props.history.push(`${this.props.event.slug}/${values.search}`)
  //     }
  // })

    render() {
      const { getFieldDecorator } = this.props.form
      const raceDay = this.props.event.date
      const isAfter = moment(raceDay, 'DD/MM/YYYY').isSameOrAfter(new Date())
      const { event } = this.props
      const Search = Input.Search
      return (
        <Form layout="horizontal" style={{ textAlign: 'center' }}/*  onSubmit={this._handleSubmit} */>

          <p className="text">{event.title}</p>

          <FormItem>
            {getFieldDecorator('search', {
                        rules: [{ required: true, message: 'Please input your Bib number!' }],
                    })(<Search
                      placeholder="Bib number"
                      enterButton="Search"
                      autoComplete="off"
                      size="default"
                      onSearch={value => this._handleSubmit(value)}
                      style={{ width: '90%' }}
                      disabled={isAfter}
                      type="number"
                    />
                        // <Input placeholder="Bib number" style={{width: "80%"}} />
                    )}
          </FormItem>
          {/* <FormItem>
                    <Button
                        type="primary"
                        htmlType="submit"
                        disabled={isAfter}>
                        Search
                    </Button>
                </FormItem> */}
        </Form>
      )
    }
}

// const WrappedSearchBar = Form.create()(SearchBar)

export default compose(
  Form.create(),
  withRouter
)(SearchBar)



// WEBPACK FOOTER //
// ./src/Home/Component/SearchBar.js